export default __webpack_public_path__ + "static/media/group.8d13f948.png";